export default __webpack_public_path__ + "static/media/ClientCare.524b22e4.svg";